import { render } from "./PrecheckIndicator.vue?vue&type=template&id=b51c31b2"
import script from "./PrecheckIndicator.vue?vue&type=script&lang=js"
export * from "./PrecheckIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__